import type {
	OrderExaminationResponseDto,
	OrderExaminationUpdateDto,
} from "Infrastructure/Api/Api";
import { patchExaminationsId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { orderKeys } from "Order/Api/orderKeys";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

const examinationMutationsResource = Resources.base.examination.mutations;

export const useEditOrderExaminationMutation = (examinationId: number) => {
	const { t } = useResource();
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: processResponse((data: OrderExaminationUpdateDto) =>
			patchExaminationsId(data, examinationId),
		),
		onError: (error) => {
			console.error(
				`${t(examinationMutationsResource.updateExaminationError)}:`,
				error,
			);
		},
		onSuccess: async (data: OrderExaminationResponseDto) => {
			await Promise.all([
				queryClient.invalidateQueries({
					queryKey: orderKeys.examinations(data.orderId),
				}),
				queryClient.invalidateQueries({
					queryKey: orderKeys.detail(data.orderId),
				}),
			]);
			toast.success(t(examinationMutationsResource.updateExaminationSuccess));
		},
	});
};
